import { json } from "svelte-i18n"
import { derived, get, writable, type Writable} from "svelte/store"
import type { FocusTypes, MinutePower } from "@/Common/constants"


export function createUserFocusPowers(trainingAdvice: Writable<any> ) {

    const currentFocusPower = writable<number>()
    const focusPowerDuration = writable<number>()
    const currentMinutePowers = derived<[Writable<any>], MinutePower[]>(
        [trainingAdvice],
        ([$trainingAdvice]) => {
            return $trainingAdvice.current_minute_powers
        }
    )

    function generateMinutePower(focus: string): number | null {
        const foc = focus.toLowerCase()
        const focusLocale = get(json)('focus')
        return focusLocale[foc]?.minute_power ?? null
    }

    function updateFocusPower(focus: FocusTypes) {
        let minutePower = generateMinutePower(focus)
        focusPowerDuration.set(minutePower),
        currentFocusPower.set(get(currentMinutePowers).find(mp => mp.x == minutePower*60)?.userp ?? null)
    }

    return {
        updateFocusPower,
        currentFocusPower,
        focusPowerDuration
    }

}



